export default {"src":"/_next/static/media/microsoft-365-logo.f9e7a689.svg","height":44,"width":40,"blurWidth":0,"blurHeight":0};